<template>
  <div>
    <ts-page-title :title="$t('generalJournalRecord.pageTitle')" :breadcrumb="[
      { text: $t('home'), href: '/' },
      {
        text: $t('generalJournalRecord.pageTitle'),
        active: true
      }
    ]" />
    <ts-panel>
      <ts-panel-wrapper>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <ts-card>
                <ts-loading-banner :loading="loading">
                  <form>
                    <fieldset>
                      <legend>{{ $t('generalJournalRecord.criteria') }}</legend>
                      <div class="row mt-3">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label class="form-col-label control-label">{{
                              $t('generalJournalRecord.branch')
                            }}</label>
                            <ts-branch-filter @filter="value => (model.branch_id = value)" :isPlaceholder="true"
                              style="width: 100%" />
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-12">
                          <label class="form-col-label control-label">{{
                            $t('generalJournalRecord.transactionDate')
                          }}</label>
                          <DatePicker v-model="model.dateRange" type="daterange" placement="bottom-end"
                            :placeholder="$t('selectDateRange')" style="width: 100%" :transfer="true" format="dd-MM-yyyy"
                            @on-change="onChangeTransactionDate"></DatePicker>
                          <div class="text-danger" v-if="errors.has('dateRange')">
                            {{ errors.first('dateRange') }}
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-12">
                          <label class="form-col-label control-label">{{
                            $t('generalJournalRecord.transactionType')
                          }}</label>
                          <Select v-model="model.tran_id" :filterable="true" :filter-by-label="true"
                            :placeholder="$t('all')" :clearable="true" style="width: 100%">
                            <Option :value="1" :key="1" label="Manual">
                              Manual
                            </Option>
                            <Option v-for="item in transactionTypeLists" :value="item.tran_id" :key="item.tran_id"
                              :label="item.tran_name">
                              {{ item.tran_name }}
                            </Option>
                          </Select>
                          <div class="text-danger" v-if="errors.has('tran_id')">
                            {{ errors.first('tran_id') }}
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-12">
                          <label class="form-col-label control-label required">{{ $t('generalLedger.currency')
                          }}</label><br />
                          <RadioGroup v-model="model.currency_id" size="small">
                            <Radio class="mt-1" :label="c.currency_id" border v-for="(c, index) in currencies"
                              :key="index">
                              {{ c.currency_code }}
                            </Radio>
                          </RadioGroup>
                          <div class="text-danger" v-if="errors.has('currency_id')">
                            {{ errors.first('currency_id') }}
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3" v-if="model.classified_by == 'standard'">
                        <div class="col-md-12">
                          <label class="form-col-label control-label required">{{ $t('generalJournalRecord.currency')
                          }}</label><br />
                          <RadioGroup v-model="model.currency_id" size="small">
                            <Radio class="mt-1" :label="c.currency_id" border v-for="(c, index) in currencies"
                              :key="index">
                              {{ c.currency_code }}
                            </Radio>
                          </RadioGroup>
                          <div class="text-danger" v-if="errors.has('currency_id')">
                            {{ errors.first('currency_id') }}
                          </div>
                        </div>
                      </div>
                      <div class="row mb-3">
                        <div class="col-md-12">
                          <label class="form-label col-label">{{
                            $t('generalJournalRecord.excelTeplate')
                          }}</label>
                        </div>
                        <div class="col-md-12">
                          <RadioGroup v-model="model.excel_template">
                            <Radio class="mt-1" :label="c.value" border v-for="(c, index) in excelTeplate"
                              :key="index">{{ c.label }}
                            </Radio>
                          </RadioGroup>
                        </div>
                      </div>
                      <div class="row mb-3 ts-justify-end ts-flex ts-space-x-2">
                        <ts-button outline color="success" @click.prevent="exportExcel" :waiting="exporting">
                          <i class="far fa-file-excel" v-if="!exporting"></i>
                          {{ $t('exportExcel') }}</ts-button>
                        <ts-button color="danger" outline @click.prevent="preview" :waiting="waiting">
                          <i class="far fa-file-pdf" v-if="!waiting"></i>
                          {{ $t('previewPdf') }}</ts-button>
                      </div>
                    </fieldset>
                  </form>
                </ts-loading-banner>
              </ts-card>
            </div>
          </div>
          <div class="col-lg-9">
            <div id="container">
              <ts-preview-pdf v-model="waiting" :src="src" />
            </div>
          </div>
        </div>
      </ts-panel-wrapper>
    </ts-panel>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import { trim } from 'lodash'
import * as FileDownload from 'downloadjs'

export default {
  name: 'generalJournalRecord',

  data() {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      errors: new Errors(),
      src: '',
      excelTeplate: [
        {
          value: 'standard',
          label: 'Standard'
        },
        {
          value: 'raw-data',
          label: 'Raw Data'
        }
      ],
      model: {
        excel_template: 'standard',
        branch_id: [],
        currency_id: null,
        tran_id: null,
        dateRange: [
          moment().format('DD-MM-YYYY'),
          moment().format('DD-MM-YYYY')
        ]
      }
    }
  },
  computed: {
    ...mapState('report/resource', ['transactionTypes', 'currencies']),

    transactionTypeLists() {
      return this.transactionTypes
    }
  },
  methods: {
    ...mapActions('report/resource', ['getTransactionType', 'getCurrency']),

    preview() {
      this.errors = new Errors()
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('report/accounting/generalJournalRecord', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.errors = new Errors()
      this.exporting = true

      this.$store
        .dispatch(
          'report/accounting/generalJournalRecordExportExcel',
          this.model
        )
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.notice({ type: 'error', text: error.message })
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    onChangeTransactionDate(dateRange) {
      this.model.dateRange = dateRange[0] && dateRange[1] ? dateRange : []
    },
    notice(not) {
      this.$Notice[not.type]({
        title: 'GENERAL JOURNAL RECORD',
        desc: not.text
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getCurrency()
      .then(() => {
          vm.model.currency_id = vm.$store.state.authUser.sys_setting.currency_id_from
        })
      vm.getTransactionType()
    })
  }
}
</script>
